import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getUserManagementFailure,
  getUserManagementSuccess,
  showUserManagementSuccess,
  showUserManagementFailure,
  updateUserManagementSuccess,
  updateUserManagementFailure,
} from "../../actions";
import {
  GET_USER_MANAGEMENT,
  SHOW_USER_MANAGEMENT,
  UPDATE_USER_MANAGEMENT,
} from "../../Actions/types";
import api from "../../../helper/api";

function* fetchUserManagement(action) {
  try {
    const response = yield api.post("/admin/user/fetch", action?.payload?.form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response?.status === 200 && response?.data?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(getUserManagementSuccess({ getData: response?.data?.data }));
    } else if(response?.status === 200 && response?.data?.status !== 200) {
      toast.error(response?.data?.message)
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(getUserManagementFailure({ getError: e }));
  }
}

function* showUserManagement(action) {
  try {
    const response = yield api.post("/admin/user/show", action?.payload?.form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response?.status === 200 && response?.data?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(showUserManagementSuccess({ showData: response?.data?.data }));
    } else if(response?.status === 200 && response?.data?.status !== 200) {
      toast.error(response?.data?.message)
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(showUserManagementFailure({ showError: e }));
  }
}

function* updateUserManagement(action) {
  try {
    const response = yield api.post("", {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response?.status === 200 && response?.data?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateUserManagementSuccess({ updateData: response?.data?.data })
      );
    } else if(response?.status === 200 && response?.data?.status !== 200) {
      toast.error(response?.data?.message)
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(updateUserManagementFailure({ updateError: e }));
  }
}

function* userManagementWatcher() {
  yield takeLatest(GET_USER_MANAGEMENT, fetchUserManagement);
}
function* showUserManagementWatcher() {
  yield takeLatest(SHOW_USER_MANAGEMENT, showUserManagement);
}
function* updateUserManagementWatcher() {
  yield takeLatest(UPDATE_USER_MANAGEMENT, updateUserManagement);
}

export default function* userManagementSaga() {
  yield all([
    userManagementWatcher(),
    showUserManagementWatcher(),
    updateUserManagementWatcher(),
  ]);
}
